import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnDestroy,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { LoadingController, NavController } from "ionic-angular";
import { CompanyManagementService } from "../../../../providers/company-management-service/company-management-service";
import { Facility } from "../../facility/facility";
import { CompanyDetails } from "../company-details";

@Component({
  selector: "company-details-facilities",
  templateUrl: "company-details-facilities.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanyDetailsFacilities),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CompanyDetailsFacilities),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyDetailsFacilities
  extends CompanyDetails
  implements ControlValueAccessor, OnDestroy
{
  facilities = [];
  private spinnerCounter: number = 0;
  private spinner: any = null;
  totalPages = 0;
  currentPage = 0;

  @Input() companyName: string = "";
  @Input() companyId: string = "";
  @Input() isEditMode: boolean = false;
  @Input() fromLocationGroup: boolean = false;
  @Input() locationGroupName: string = "";

  // set value(value: any) {
  //     this.innerFormGroup.patchValue(value);
  // }
  constructor(
    protected navCtrl: NavController,
    protected formBuilder: FormBuilder,
    protected companyManagementService: CompanyManagementService,
    protected loader: LoadingController,
    private ref: ChangeDetectorRef
  ) {
    super(formBuilder);
  }

  openDetails(facility: any) {
    if (this.fromLocationGroup) {
      // open Facility from Location Group
      this.navCtrl.push(Facility, {
        facilityData: facility,
        locationGroupName: this.locationGroupName,
        companyName: this.companyName,
        companyId: this.companyId,
      });
    } else {
      // open Facility from Company Page
      this.navCtrl.push(Facility, {
        facilityData: facility,
        companyName: this.companyName,
        companyId: this.companyId,
      });
    }
  }

  increaseSpinnerCount(message: string = "Loading ...") {
    this.spinnerCounter++;
    if (this.spinnerCounter && !this.spinner) {
      this.spinner = this.loader.create({
        content: message,
      });
      this.spinner.present();
    }
  }

  // decremental loader function
  decreaseSpinnerCount() {
    this.spinnerCounter--;
    if (this.spinnerCounter <= 0 && this.spinner) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/company-details/facilitities/company-details-facilities.ts